<div id="move-top" class="scroll-to-top" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <a class="btn" pageScroll href="#base_wrap">
    <span>></span>
    TOP
  </a>
</div>
